import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { getPersonalizationLabelWithPrice } from '../utils/ProductUtils';
import { mapContextToProps } from '../OlsShopContext';

export class PersonalizationText extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      showInput: false,
      userText: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getIncreaseByLabel = this.getIncreaseByLabel.bind(this);
  }

  handleChange(e) {
    const id = this.props.id;
    const isEnabled = e.target.checked;

    this.setState({
      showInput: isEnabled
    });

    const { userText } = this.state;
    this.props.onChange(id, isEnabled, userText);
  }

  handleInputChange(e) {
    const id = this.props.id;
    const isEnabled = this.props.required || this.state.showInput;
    const userText = e.target.value;

    this.setState({
      userText: userText
    });

    this.props.onChange(id, isEnabled, userText);
  }

  getIncreaseByLabel(labelText) {
    return getPersonalizationLabelWithPrice({
      name: labelText,
      price: this.props.increase_by,
      translate: this.props.translate
    });
  }

  render() {
    const { showInput, userText } = this.state;
    const translate = this.props.translate;
    const {
      id,
      required: isRequired,
      errorMessage,
      description: descriptionText,
      labelError,
      name
    } = this.props;
    const fieldId = 'personalization-text-' + id;
    const checkboxId = 'personalization-checkbox-' + id;
    const showField = isRequired || (!isRequired && showInput);
    const {
      Block,
      Label,
      Input: { Checkbox, TextArea }
    } = UX2.Element;
    const { Form } = UX2.Group;

    const styles = {
      group: {
        marginBottom: 'small'
      },
      container: {
        marginBottom: 'small'
      },
      label: {
        marginBottom: 0
      },
      labelWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 'xsmall'
      },
      error: {
        marginTop: 'xxsmall',
        fontColor: 'error',
        fontSize: 'small'
      },
      description: {
        marginBottom: 'xxsmall',
        fontSize: 'small',
        fontColor: 'lowContrast'
      },
      checkbox: {
        marginRight: 'xsmall'
      }
    };

    let label = null;
    let field = null;

    if (!isRequired) {
      let labelText = this.getIncreaseByLabel(name);
      labelText = translate('products.optional_label_text', {
        name: labelText
      });
      label = (
        <Block tag='label' style={ styles.labelWrapper }>
          <Checkbox
            id={ checkboxId }
            tag='input'
            type='checkbox'
            checked={ showInput }
            onChange={ this.handleChange }
            style={ styles.checkbox }
          />
          <Label
            htmlFor={ checkboxId }
            children={ labelText }
            style={ styles.label }
            alert={ labelError }
          />
        </Block>
      );
    } else {
      const labelText = this.getIncreaseByLabel(name);
      label = (
        <Label
          htmlFor={ fieldId }
          children={ labelText }
          style={{ ...styles.label, marginBottom: 'xsmall' }}
          alert={ labelError }
        />
      );
    }

    if (showField) {
      field = (
        <Block>
          { descriptionText && <Block children={ descriptionText } style={ styles.description } /> }
          <TextArea
            tag='textarea'
            id={ fieldId }
            value={ userText }
            onChange={ this.handleInputChange }
          />
          { errorMessage && <Block children={ errorMessage } style={ styles.error } /> }
        </Block>
      );
    }

    return (
      <Form.Group style={ styles.group }>
        <Block style={ styles.container }>
          { label }
          { field }
        </Block>
      </Form.Group>
    );
  }
}

PersonalizationText.propTypes = {
  name: PropTypes.string,
  errorMessage: PropTypes.any,
  labelError: PropTypes.bool,
  onChange: PropTypes.func,
  description: PropTypes.string,
  required: PropTypes.bool,
  id: PropTypes.any,
  increase_by: PropTypes.any,
  translate: PropTypes.func
};

PersonalizationText.defaultProps = {
  labelError: false,
  translate: () => {}
};

export default mapContextToProps(PersonalizationText, context => ({
  translate: context.translate
}));
